// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"Citizen_fullWidth__onoio"};